var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3299 7.92003C20.9199 7.92003 20.5799 7.58003 20.5799 7.17003V5.35003C20.5799 4.62003 19.9899 4.03003 19.2599 4.03003H4.73992C4.00992 4.03003 3.41992 4.62003 3.41992 5.35003V7.18003C3.41992 7.59003 3.07992 7.93003 2.66992 7.93003C2.25992 7.93003 1.91992 7.59003 1.91992 7.17003V5.35003C1.91992 3.79003 3.18992 2.53003 4.73992 2.53003H19.2599C20.8199 2.53003 22.0799 3.80003 22.0799 5.35003V7.18003C22.0799 7.59003 21.7499 7.92003 21.3299 7.92003Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.4701C11.59 21.4701 11.25 21.1301 11.25 20.7201V4.11011C11.25 3.70011 11.59 3.36011 12 3.36011C12.41 3.36011 12.75 3.70011 12.75 4.11011V20.7201C12.75 21.1401 12.41 21.4701 12 21.4701Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9396 21.47H8.05957C7.64957 21.47 7.30957 21.13 7.30957 20.72C7.30957 20.31 7.64957 19.97 8.05957 19.97H15.9396C16.3496 19.97 16.6896 20.31 16.6896 20.72C16.6896 21.13 16.3496 21.47 15.9396 21.47Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.5b0b3148e810e1680f5d3cd25337c432.svg";
export { ForwardRef as ReactComponent };